"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
const InstructionMessage_1 = __importDefault(require("./InstructionMessage"));
const Serializer_1 = require("../../../Serializer");
const StreamID_1 = require("../../../utils/StreamID");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class InstructionMessageSerializerV2 extends Serializer_1.Serializer {
    toArray(instructionMessage) {
        return [
            VERSION,
            TrackerMessage_1.default.TYPES.InstructionMessage,
            instructionMessage.requestId,
            instructionMessage.streamId,
            instructionMessage.streamPartition,
            instructionMessage.nodeIds,
            instructionMessage.counter
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, streamId, streamPartition, nodeIds, counter] = arr;
        return new InstructionMessage_1.default({
            version,
            requestId,
            streamId: (0, StreamID_1.toStreamID)(streamId),
            streamPartition,
            nodeIds,
            counter
        });
    }
}
exports.default = InstructionMessageSerializerV2;
TrackerMessage_1.default.registerSerializer(VERSION, TrackerMessage_1.default.TYPES.InstructionMessage, new InstructionMessageSerializerV2());
//# sourceMappingURL=InstructionMessageSerializerV2.js.map